import { render, staticRenderFns } from "./DlsCz.vue?vue&type=template&id=023528d5"
import script from "./DlsCz.vue?vue&type=script&lang=js"
export * from "./DlsCz.vue?vue&type=script&lang=js"
import style0 from "./DlsCz.vue?vue&type=style&index=0&id=023528d5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports